import "./Footer.scss";

const Footer = () => {
    return (
        <footer id="contact" className="contact-section" aria-labelledby="contact-heading">

            <div>
                <p>© 2026 All Rights Reserved</p>
                <p>Made by Chloe Pappas</p>
            </div>


            <div>
                <div className="contact-buttons">
                    <a
                        href="mailto:chloeoliviapappas@gmail.com"
                        className="contact-btn"
                        aria-label="Send email to Chloe Pappas"
                    >
                        <i className="bi bi-envelope-fill" aria-hidden="true"></i>
                        Email
                    </a>
                    <a
                        href="https://www.linkedin.com/in/chloe-pappas/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact-btn"
                        aria-label="Visit Chloe Pappas LinkedIn profile in new tab"
                    >
                        <i className="bi bi-linkedin" aria-hidden="true"></i>
                        LinkedIn
                    </a>
                    <a
                        href="https://www.github.com/cpappas18"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact-btn github-btn"
                        aria-label="Visit Chloe Pappas GitHub profile in new tab"
                    >
                        <i className="bi bi-github" aria-hidden="true"></i>
                        GitHub
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer;